import React from "react";
import FieldLabel from "../../../components/label";
import ChipSelect from "../../../components/chipSelect";
import { withStyles } from "@mui/styles";
import { useStyles } from "../indexFormStyles";
import { Box, FormControl, MenuItem, Select, TextField } from "@mui/material";
import { getMinDobDate, getMaxDobDate } from "../../../helpers/buyflow";
import { buildNomineeRelationshipList } from "../../../helpers/nominee";

function NomineePersonalDetails({
  classes: { formGroup },
  dateRange,
  errorMessage,
  form,
  handleChange,
  handleChangeChipSelect,
  options,
  validateInputLength,
}) {
  return (
    <>
      <Box className={formGroup} pt={0}>
        <FieldLabel label={"Full Name*"} />
        <TextField
          id="standard-basic"
          variant="outlined"
          value={form.nominee_name}
          name="nominee_name"
          onChange={handleChange}
          onInput={validateInputLength}
          autoComplete="off"
          helperText={errorMessage.nominee_name}
          fullWidth
        />
      </Box>

      <Box className={formGroup} pt={0}>
        <FieldLabel label={"Relationship*"} />
        <FormControl
          variant="outlined"
          style={{ width: "100%", textAlign: "left" }}
          fullWidth
        >
          <Select
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            value={form.nominee_relationship}
            onChange={handleChange}
            name="nominee_relationship"
            disabled={!form.nominee_name}
            placeholder="Select"
          >
            <MenuItem value={""}>
              <em>Select</em>
            </MenuItem>
            {buildNomineeRelationshipList(form.nominee_age).map((item) => {
              return (
                <MenuItem value={item} key={item}>
                  {item}
                </MenuItem>
              );
            })}
          </Select>
          {errorMessage.nominee_relationship && (
            <Box className="error-message">{"Please select relationship"}</Box>
          )}
        </FormControl>
      </Box>

      <Box className={formGroup} pt={0}>
        {/* InputProps=
        {{
          inputProps: { min: getMinDobDate(100), max: getMaxDobDate(0) },
        }} */}
        <FieldLabel label={"Date of Birth*"} />
        <TextField
          type="date"
          id="standard-basic"
          variant="outlined"
          value={form.nominee_dob}
          name="nominee_dob"
          onChange={handleChange}
          autoComplete="off"
          helperText={errorMessage.nominee_dob}
          fullWidth
          InputProps={{
            inputProps: {
              min: dateRange.nominee.min,
              max: dateRange.nominee.max,
            },
          }}
          disabled={!form.nominee_relationship}
        />
      </Box>

      <Box className={formGroup} pt={0}>
        <FieldLabel label={"Gender*"} />
        <ChipSelect
          fieldname={"nominee_gender"}
          handleChange={handleChangeChipSelect}
          options={options.gender}
          selectedItem={form.nominee_gender}
          disabled={true}
        />
      </Box>
    </>
  );
}

export default withStyles(useStyles, { withTheme: true })(
  NomineePersonalDetails
);
